module.exports = __webpack_public_path__ + "static/media/rStoch.10a1d1cb.png";